import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  Input,
  Label,
  Button,
  Table,
} from "reactstrap";
import swal from "sweetalert";
import axiosConfig from "../../AxiosConfig";

export default function Costing() {
  const [products, setProducts] = useState([]);

  const [formData, setFormData] = useState({
    productId: "",
    productName: "",

    purchaseRate: 0,
    qty: 1,

    totalPurchase: 0,

    conversionCost: "",
    laborCost: "",
    rentCost: "",
    otherCost: "",

    netCosting: 0,
  });

  // 🔥 Fetch Products
  const fetchProducts = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem("userData"));

      const res = await axiosConfig.get(
        `/product/view-product-purchase/${userData?.database}`
      );

      const costingpro = res?.data?.Product
      const costingProducts =
  costingpro.filter(
    (item) =>
      item?.productCosting?.length > 0
  );

      setProducts(costingProducts || []);
      
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  // 🔥 Calculate Net Costing
  useEffect(() => {

    // ✅ Purchase Total
    const purchaseTotal =
      Number(formData.purchaseRate || 0) *
      Number(formData.qty || 0);

    // ✅ Final Net Costing
    const finalCost =
      purchaseTotal +
      Number(formData.conversionCost || 0) +
      Number(formData.laborCost || 0) +
      Number(formData.rentCost || 0) +
      Number(formData.otherCost || 0);

    setFormData((prev) => ({
      ...prev,
      totalPurchase: purchaseTotal,
      netCosting: finalCost,
    }));

  }, [
    formData.purchaseRate,
    formData.qty,
    formData.conversionCost,
    formData.laborCost,
    formData.rentCost,
    formData.otherCost,
  ]);

  // 🔥 Product Select
  const handleProduct = (e) => {
    const selected = products.find(
      (p) => p._id === e.target.value
    );

    setFormData({
      ...formData,
      productId: selected?._id || "",
      productName: selected?.Product_Title || "",
      purchaseRate: Number(selected?.Purchase_Rate || 0),
    });
  };

  // 🔥 Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    const user = JSON.parse(localStorage.getItem("userData"));

    const payload = {
      created_by: user?._id,
      database: user?.database,

      productId: formData.productId,
      productName: formData.productName,

      purchaseRate: formData.purchaseRate,

      qty: formData.qty,

      totalPurchase: formData.totalPurchase,

      conversionCost: formData.conversionCost,
      laborCost: formData.laborCost,
      rentCost: formData.rentCost,
      otherCost: formData.otherCost,

      netCosting: formData.netCosting,
    };

    console.log("FINAL PAYLOAD =>", payload);

    try {
      // 🔥 Save API
      const res = await axiosConfig.post(
        "/product-costing/save",
        payload
      );

      if (res?.status === 200 || res?.data?.status) {
        swal(
          "Success",
          "Costing Saved Successfully",
          "success"
        );

        setFormData({
          productId: "",
          productName: "",
          purchaseRate: 0,

          conversionCost: "",
          laborCost: "",
          rentCost: "",
          otherCost: "",

          netCosting: 0,
        });
      }
    } catch (err) {
      console.log(err);

      swal("Error", "Something went wrong", "error");
    }
  };

  return (
    <div className="erp-page-grid">
      <Card className="erp-card">
        <CardBody>
          <h3>Product Costing</h3>

          <form onSubmit={handleSubmit}>
            <Row>
              {/* Product */}
              <Col md="4">
                <Label>Select Product</Label>

                <Input
                  type="select"
                  value={formData.productId}
                  onChange={handleProduct}
                >
                  <option value="">
                    Select Product
                  </option>

                  {products.map((item) => (
                    <option
                      key={item._id}
                      value={item._id}
                    >
                      {item.Product_Title}
                    </option>
                  ))}
                </Input>
              </Col>

              {/* Purchase Rate */}
              <Col md="4">
                <Label>Purchase Rate</Label>

                <Input
                  value={formData.purchaseRate}
                  disabled
                />
              </Col>
              <Col md="4">
                <Label>Qty</Label>

                <Input
                  type="number"
                  value={formData.qty}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      qty: e.target.value,
                    })
                  }
                />
              </Col>
              <Col md="4">
                <Label>Total Purchase</Label>

                <Input
                  value={formData.totalPurchase}
                  disabled
                  style={{
                    background: "#f1f5f9",
                    fontWeight: "bold",
                  }}
                />
              </Col>
              {/* Conversion */}
              <Col md="4">
                <Label>Conversion Cost</Label>

                <Input
                  type="number"
                  value={formData.conversionCost}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      conversionCost: e.target.value,
                    })
                  }
                />
              </Col>
            </Row>

            {/* Row 2 */}
            <Row className="mt-2">
              <Col md="4">
                <Label>Labor Cost</Label>

                <Input
                  type="number"
                  value={formData.laborCost}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      laborCost: e.target.value,
                    })
                  }
                />
              </Col>

              <Col md="4">
                <Label>Rent Cost</Label>

                <Input
                  type="number"
                  value={formData.rentCost}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      rentCost: e.target.value,
                    })
                  }
                />
              </Col>

              <Col md="4">
                <Label>Other Cost</Label>

                <Input
                  type="number"
                  value={formData.otherCost}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      otherCost: e.target.value,
                    })
                  }
                />
              </Col>
            </Row>

            {/* Net Costing */}
            <Row className="mt-3">
              <Col md="4">
                <Label>Net Costing</Label>

                <Input
                  value={formData.netCosting}
                  disabled
                  style={{
                    fontWeight: "bold",
                    background: "#f1f5f9",
                  }}
                />
              </Col>
            </Row>

            <Button
              color="primary"
              type="submit"
              style={{ marginTop: "20px" }}
            >
              Save Costing
            </Button>
          </form>

          {/* Preview Table */}
          <div style={{ marginTop: "30px" }}>
            <Table bordered responsive>
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Purchase</th>
                  <th>Conversion</th>
                  <th>Labor</th>
                  <th>Rent</th>
                  <th>Other</th>
                  <th>Net Costing</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>{formData.productName}</td>
                  <td>{formData.purchaseRate}</td>
                  <td>{formData.conversionCost}</td>
                  <td>{formData.laborCost}</td>
                  <td>{formData.rentCost}</td>
                  <td>{formData.otherCost}</td>
                  <td>
                    <strong>
                      {formData.netCosting}
                    </strong>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}